import { Directive, OnInit, OnDestroy, Input, HostListener } from '@angular/core';
import { AutoScrollService } from '../services/auto-scroll.service';

@Directive({
  selector: '[appAutoScroll]',
  standalone: true
})
export class AutoScrollDirective implements OnInit, OnDestroy {
  @Input() scrollRate: number = 0.5;
  @Input() startDelay: number = 2000;
  @Input() pauseTime: number = 3000;

  constructor(private scrollService: AutoScrollService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.scrollService.beginScroll(this.scrollRate);
    }, this.startDelay);
  }

  ngOnDestroy(): void {
    this.scrollService.endScroll();
  }

  @HostListener('wheel')
  @HostListener('touchstart')
  @HostListener('touchmove')
  onUserAction(): void {
    this.scrollService.pauseForDuration(this.pauseTime);
  }
}